import { render, staticRenderFns } from "./VDescPreview.vue?vue&type=template&id=afb30246&"
import script from "./VDescPreview.vue?vue&type=script&lang=js&"
export * from "./VDescPreview.vue?vue&type=script&lang=js&"
import style0 from "./VDescPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports